import React from 'react'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import { GroupedChange } from '../types'
import ChangeEntry from './ChangeEntry'
import { formatDateHeader } from '../utils/formatters'

interface ChangeEntryGroupProps {
    group: GroupedChange
}

const ChangeEntryGroup = ({ group }: ChangeEntryGroupProps) => {
    const userName = group.user?.name || 'Unknown User'
    const headerText = formatDateHeader(group.date, userName)

    return (
        <Stack gap={2}>
            {/* Header: Date and User */}
            <Typography variant="14x500" color="figma.grayscale.textHier1">
                {headerText}
            </Typography>

            {/* Changes */}
            <Stack gap={1.5}>
                {group.changes.map((change) => (
                    <ChangeEntry key={change._id} change={change} />
                ))}
            </Stack>

            <Divider sx={{ borderColor: 'figma.grayscale.stroke' }} />
        </Stack>
    )
}

export default ChangeEntryGroup
